import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { setSearchText } from "../../../store/userProfileLocation";

export const LocationSearchBar = () => {
    const dispatch = useDispatch();
    const searchText = useSelector((state: RootState) => state.userProfileLocation.searchText);

    return (
        <IonSearchbar
            value={searchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSearchText(value));
            }}
            debounce={700}
            placeholder={"Buscar Plantas..."}
            autocomplete="off"
        />
    );
};